module.exports = __webpack_public_path__ + "static/media/1007124.d05d80a0.png";